module.exports = __webpack_public_path__ + "img/ru_success_6.7c0a9891.png";